/**
 * DTOs for the Account User Import planning call.
 * Mirrors server/Proximity.Api/DTO/ImportUserInfo.cs — keep the two in step.
 *
 * The server decides IDENTITY only (Add / Match / Reject). Update-vs-NoChange is computed
 * on the client, because it depends on the Shipping and Program group codes the admin maps
 * after upload — see ImportUsersComponent.recomputePlans().
 */

/** The identity decision the server reaches about one row. */
export type ImportUserDecision = 'Add' | 'Match' | 'Reject';

/** One import row as the client sends it for planning. */
export class ImportUserPlanRequestRow {
  ImportId = '';
  FirstName = '';
  LastName = '';
  Email = '';
  ApiLink = '';
}

/** Request envelope. AccountId scopes the match to one account. */
export class ImportUserPlanRequest {
  AccountId = '';
  Rows: ImportUserPlanRequestRow[] = [];
}

/** A user group the matched Account User already belongs to. */
export class ImportUserGroupRef {
  Id = '';
  Name = '';
}

/** The server's plan for one row. For a Match, carries what the delta rules need. */
export class ImportUserPlanRow {
  ImportId = '';
  Decision: ImportUserDecision = 'Add';
  RejectReason = '';
  /** Generated username. Set for Add rows only; a Match keeps the one it has. */
  UserName = '';
  MatchedAccountUserId?: string;
  MatchedProximityUserId?: string;
  MatchedDisplayName = '';
  /** Empty means rule 3 can fill the ApiLink in. */
  ExistingApiLink = '';
  /** Null means rule 4 can fill the Hire Date in. */
  ExistingHireDate?: Date;
  ExistingShippingGroups: ImportUserGroupRef[] = [];
  ExistingProgramGroups: ImportUserGroupRef[] = [];
}
